module.exports = __webpack_public_path__ + "img/HC1002-01.732bffdb.jpg";